import { Link } from "react-router-dom";
import { news } from "@/mocks/specials";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsBoard() {
  const [lead, ...rest] = news;

  return (
    <section aria-label="热门剧情资讯" className="mt-12">
      <SectionHeading
        eyebrow="Plot Journal"
        title="热门剧情资讯"
        description="作品解析、时间线梳理与幕后笔记，帮助你在观看前后补全剧情理解。"
        actionLabel="更多专题内容"
        actionPath="/special"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1.05fr_1fr]">
        <article className="group flex flex-col justify-between overflow-hidden rounded-lg border border-background-200/90 bg-primary-950 p-5 md:p-6">
          <div>
            <div className="flex items-center gap-2 text-[11px]">
              <span className="rounded bg-accent-500 px-2 py-0.5 font-medium text-primary-950">{lead.category}</span>
              <span className="text-primary-300">{lead.date}</span>
            </div>
            <h3 className="mt-4 font-heading text-[20px] leading-8 font-semibold text-background-50 md:text-[23px]">
              <Link to="/special" className="transition-colors hover:text-accent-300">
                {lead.title}
              </Link>
            </h3>
            <p className="mt-3 text-[13px] leading-7 text-primary-200">{lead.excerpt}</p>
          </div>
          <Link
            to="/special"
            className="mt-6 inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-primary-700 px-3 py-2 text-[12px] text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </article>

        <ul className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200/90 bg-background-50">
          {rest.slice(0, 5).map((item) => (
            <li key={item.id}>
              <Link to="/special" className="group flex items-start gap-3 px-4 py-3.5 transition-colors hover:bg-background-100/70">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded bg-secondary-100 text-secondary-700">
                  <i className="ri-article-line text-xs" />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="line-clamp-2 text-[13px] leading-6 font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </p>
                  <p className="mt-1 flex items-center gap-2 text-[10px] text-foreground-400">
                    <span className="text-secondary-700">{item.category}</span>
                    <span>·</span>
                    <span>{item.date}</span>
                  </p>
                </div>
                <i className="ri-arrow-right-up-line mt-1 shrink-0 text-sm text-foreground-300 transition-colors group-hover:text-accent-600" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}